// Generated by CoffeeScript 2.7.0
var RadioButtonMixin;

export default RadioButtonMixin = {
  data: function() {
    return {
      otherOption: this.field.generateOtherOptionProxy()
    };
  },
  computed: {
    valuePresent: function() {
      return Boolean(this.value.length);
    }
  },
  methods: {
    validateOtherOption: function() {
      var is_selected;
      is_selected = _.any(this.value, (option) => {
        return option === this.otherOption;
      });
      if (is_selected && !this.otherOption.value) {
        return this._addError('其他选项不能为空');
      }
    },
    _parseValueToEntries: function() {
      var entries, entry, option;
      entry = _.first(this.entries);
      option = _.first(this.value);
      entries = [];
      if (entry) {
        if (option) {
          if (option.id !== 0 && option.id === entry.option_id) {
            entries.push(_.clone(entry));
          } else {
            entries.push(_.extend(_.clone(entry), {
              _destroy: true
            }));
            entries.push(this._generateEntryFromOption(option));
          }
        } else {
          entries.push(_.extend(_.clone(entry), {
            _destroy: true
          }));
        }
      } else {
        if (option) {
          entries.push(this._generateEntryFromOption(option));
        }
      }
      return entries;
    },
    _validate: function() {
      this.validatePresence();
      return this.validateOtherOption();
    },
    _initDefaultEntries: function(entries) {
      var entry;
      if (entry = entries[0]) {
        return [entry];
      } else {
        return [];
      }
    },
    _parseEntriesToValue: function(entries) {
      var entry, option;
      entry = entries[0];
      if (!entry) {
        return this.value = [];
      }
      // 普通选项
      option = entry.option_id ? _.find(this.field.options, function(item) {
        return item.id === entry.option_id;
      }) : this.field.hasOtherOption ? _.tap(this.otherOption, function(obj) {
        return obj.value = entry.value;
      }) : void 0;
      // 如果是缓存的选中项，则应该参与计数，来自于服务器选中的则无需参与计数
      return this.value = option ? (!entry.id ? option.incrementCounter() : void 0, [option]) : [];
    },
    _generateEntryFromOption: function(option) {
      return {
        value: option.value,
        field_id: this.field.id,
        option_id: option.id
      };
    }
  }
};
